import PropTypes from 'prop-types'


const PasswordFlyout = ({header, subtitle}) => (
  <section className='password-flyout'>
    <section>
      <section className='header'>
        {header}
      </section>
      {subtitle && (
        <section className='flyout-subtitle'>
          {subtitle}
        </section>
      )}
    </section>
  </section>
)

PasswordFlyout.propTypes = {
  header: PropTypes.string,
  subtitle: PropTypes.string
}

export default PasswordFlyout
